import type { WidgetStyle } from '@/types/widget';

export const formatValue = (val: any, style: WidgetStyle, fieldName?: string) => {
    if (val === null || val === undefined) return '';
    if (typeof val === 'object') {
        try {
            return JSON.stringify(val);
        } catch {
            return '[Complex Data]';
        }
    }
    if (typeof val !== 'number') return String(val);

    // Resolve effective style
    const effectiveStyle = (fieldName && style.seriesSettings?.[fieldName])
        ? { ...style, ...style.seriesSettings[fieldName] }
        : style;

    let num = val;
    let suffix = '';

    if (effectiveStyle.units === 'auto') {
        if (Math.abs(num) >= 1.0e9) { num /= 1.0e9; suffix = 'B'; }
        else if (Math.abs(num) >= 1.0e6) { num /= 1.0e6; suffix = 'M'; }
        else if (Math.abs(num) >= 1.0e3) { num /= 1.0e3; suffix = 'K'; }
    } else if (effectiveStyle.units === 'K') { num /= 1.0e3; suffix = 'K'; }
    else if (effectiveStyle.units === 'M') { num /= 1.0e6; suffix = 'M'; }
    else if (effectiveStyle.units === 'B') { num /= 1.0e9; suffix = 'B'; }

    const decimals = effectiveStyle.decimals ?? 0;

    let formatted = num.toFixed(decimals);

    if (effectiveStyle.formatType === 'currency') {
        const currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: effectiveStyle.currency || 'USD',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
        return currencyFormatter.format(num) + (suffix ? `${suffix}` : '');
    } else if (effectiveStyle.formatType === 'percent') {
        return (num * 100).toFixed(decimals) + '%';
    }

    return formatted + suffix;
};
